import React, { Fragment } from 'react'
import styled from 'styled-components'

import DatePickerAntd from 'antd/lib/date-picker'
require('antd/lib/date-picker/style')

const StyledDatePicker = styled(DatePickerAntd)`
  ${props => (props.pickerWidth ? `width: ${props.pickerWidth}` : '')};
`

const StyledRangePicker = styled(DatePickerAntd.RangePicker)``

const StyledCalendarContainer = styled.div`
  display: inline-block;
  .ant-calendar {
    width: 325px;
  }
  .ant-calendar-cell {
    padding: 6px 0;
  }
  .ant-calendar-date {
    height: 25px;
    line-height: 24px;
  }
  .ant-calendar-cell.ant-calendar-today .ant-calendar-date {
    padding-left: 0;
    &::before {
      width: 25px;
      height: 25px;
      left: 8px;
    }
  }
`
const StyledRangePickerCalendarContainer = styled(StyledCalendarContainer)`
  .ant-calendar {
    width: 560px;
  }
`

class DatePicker extends React.Component {
  render () {
    const { color, containerClassname } = this.props
    return (
      <Fragment>
        <StyledCalendarContainer id='calendarContainer' color={color} className={containerClassname} />
        <StyledDatePicker getCalendarContainer={() => document.getElementById('calendarContainer')} {...this.props} />
      </Fragment>
    )
  }
}

class RangePicker extends React.Component {
  render () {
    return (
      <Fragment>
        <StyledRangePickerCalendarContainer id='rangePickerCalendarContainer' />
        <StyledRangePicker
          getCalendarContainer={() => document.getElementById('rangePickerCalendarContainer')}
          {...this.props}
        />
      </Fragment>
    )
  }
}

DatePicker.RangePicker = RangePicker
DatePicker.MonthPicker = DatePickerAntd.MonthPicker

export default DatePicker
